import React from 'react'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconList } from '../../../../shared/icon/icon'
import { useRouteMatch } from 'react-router-dom'
import { Menu, MenuPurge, MenuRestore } from '../../../../shared/menu/menu'
import { useParamsInt } from '../../../../shared/hooks/location'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { useApiListManageAssessment } from '../../../../api-new/state/assessment'
import { useRoleOrgAssessmentManage } from '../../../../role/hook/role-org'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'

export function AssessmentManageRecycle() {
  const { nodeID } = useParamsInt()

  const { url } = useRouteMatch()

  const apiListManageAssessment = useApiListManageAssessment()

  const roleOrgAssessmentManage = useRoleOrgAssessmentManage()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => await apiListManageAssessment.get(`deleted?nodeID=${nodeID}`)
  const handleDestroyed = () => apiListManageAssessment.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListManageAssessment.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That assessment was already removed.'), err)
    }
    await apiListManageAssessment.get(`deleted?nodeID=${nodeID}`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListManageAssessment} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="title" sortable filter />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show={roleOrgAssessmentManage.accessDelete} />
                  <MenuPurge to={`${url}/purge/${row.id}`} show={roleOrgAssessmentManage.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
